import { useTranslation } from 'react-i18next';

export const useTqEnTimelinessResponseStatsLabels = (): Record<string, string> => {
  const { t } = useTranslation('tqen_timelines_response_stats_annual_report');

  const tqEnTimelinessResponseStatsLabels: Record<string, string> = {
    totalConsultationRequestsReceived: t(
      'tqen_total_consultation_requests_received',
      'Total number of consultation requests received'
    ),
    totalConsultationsRespondedInAgreedTimeframe: t(
      'tqen_total_consultations_responded_in_agreed_timeframe',
      'Total number of consultation requests responded to with a substantive response within the agreed timeframe'
    ),
    percentageConsultationsRespondedInAgreedTimeframe: t(
      'tqen_percentage_consultations_responded_in_agreed_timeframe',
      'Percentage of consultation requests responded to with a substantive response within the agreed timeframe'
    ),
    totalConsultationsWithResponsesWithin21Days: t(
      'tqen_total_consultations_with_responses_within_21_days',
      'Total number of consultation requests responded to with a substantive response within 21 days'
    ),
    percentageConsultationsWithResponsesWithin21Days: t(
      'tqen_percentage_consultations_with_responses_within_21_days',
      'Percentage of consultation requests responded to with a substantive response within 21 days'
    ),
    totalConsultationsRespondedLate: t(
      'tqen_total_consultations_responded_late',
      'Total number of consultations with late responses issued'
    ),
    percentageConsultationsRespondedLate: t(
      'tqen_percentage_consultations_responded_late',
      'Percentage of consultations with late responses issued'
    ),
    totalConsultationsWithOutstandingResponses: t(
      'tqen_total_consultations_with_outstanding_responses',
      'Total number of consultations with outstanding responses'
    ),
    averageDaysTakenToRespondRequests: t(
      'tqen_average_days_taken_to_respond_requests',
      'Average number of days taken to make a substantive response to requests'
    ),
  };

  return tqEnTimelinessResponseStatsLabels;
};
